<ef-process-detail [process]="process$ | async"></ef-process-detail>

<div class="col xl:col-12 lg:col-12 md:col-12 sm:col-12 xs:col-12 p-2">
    <div class="shadow-2 surface-card border-round p-4 h-full">
        <div class="flex align-items-start mb-5">
            <div class="ml-3">
                <span class="block text-900 mb-1 text-xl font-medium">Send Journal Entry</span>
                <p class="text-600 mt-0 mb-0">Send journal entries for labor and leave accrual to QuickBooks.</p>
            </div>
        </div>
        <div class="ml-3">
            <ef-send-journal-entry-filter
                [payPeriodsSelectItems]="payPeriodDatesSelectItems$ | async"
                [payPeriods]="payPeriodDates$ | async"
                (FilterChanged)="onFilterChanged($event)"
            ></ef-send-journal-entry-filter>

            <p-messages></p-messages>

            <ef-send-journal-entry-presenter
                [Filter]="FilterChanged.asObservable() | async"
                [externalIntegration]="externalIntegration$ | async"
                (SendPayPeriodLabor)="onSendPayPeriodLabor()"
                (SendAccruals)="onSendAccruals()"
                (SendLeaveAccruals)="onSendLeaveAccruals()"
                (SendGovConPayPayroll)="onSendGovConPayPayroll()"
            ></ef-send-journal-entry-presenter>
        </div>
    </div>
</div>

<!-- <div style="display: flex;">
<ef-send-journal-entry-filter
    [payPeriodsSelectItems]="payPeriodDatesSelectItems$ | async"
    [payPeriods]="payPeriodDates$ | async"
    (FilterChanged)="onFilterChanged($event)"
></ef-send-journal-entry-filter>
<p-messages></p-messages>
</div>
<ef-send-journal-entry-presenter
    [Filter]="FilterChanged.asObservable() | async"
    (SendPayPeriodLabor)="onSendPayPeriodLabor()"
    (SendAccruals)="onSendAccruals()"
    (SendLeaveAccruals)="onSendLeaveAccruals()"
></ef-send-journal-entry-presenter> -->
